// extracted by mini-css-extract-plugin
export var active = "_kb-2";
export var recordingDot = "_kb-1";
export var recordingIndicator = "_kb-0";